import {getBlockStringAfter} from "./getBlockStringAfter.js";
export const getLineStringAfter = (editor) => {
  const blockStringAfterCursor = getBlockStringAfter(editor);
  const lines = blockStringAfterCursor.split("\n");
  return lines[0];
};
